export const performancereview= 
    {
      "id": 0,
      "name": "Performance Review",
      "prompts": [
        {
          "id": 1,
          "who": "Task",
          "what": "Write a performance review."
        },
        {
          "id": 2,
          "who": "Name",
          "what": "Eric"
        },
        {
          "id": 3,
          "who": "Title",
          "what": "Junior Software Developer"
        },
        {
          "id": 4,
          "who": "Deadlines",
          "what": "Meets it very often. His coding is bug free."
        },
        {
          "id": 5,
          "who": "Team member",
          "what": "Participates well."
        },
  
      ]
    }

    export const inventory = 
    {
      "id": 0,
      "name": "Calculation",
      "prompts": [
        {
          "id": 1,
          "who": "Required quantity:",
          "what": `coffee bags: 100\ntea begs: 30\neggs: 3 dozen\nmilk: 5 gallons`
        },
        {
          "id": 2,
          "who": "Used quantity:",
          "what": `coffee bags: 20\nmilk: 2 gallons\neggs: 1 dozen\ntea: 2 begs`
        },
        {
          "id": 3,
          "who": "Task:",
          "what": `What needs to be ordered to resupply all items?\nPresent data in a CSV format and a tabular form.`
        },
      ]
    }




export const emailproperty = 
    {
        "id": 0,
        "name": "Email",
        "prompts": [
          {
            "id": 1,
            "who": "Task",
            "what": "Write an email about this property."
          },
          {
            "id": 2,
            "who": "Property",
            "what": "Two story house"
          },
          {
            "id": 3,
            "who": "Bedrooms",
            "what": "4"
          },
          {
            "id": 4,
            "who": "Bathrooms",
            "what": "3.5"
          },
          {
            "id": 5,
            "who": "Condition",
            "what": "recent update"
          },
          {
            "id": 6,
            "who": "City",
            "what": "Evanston"
          },
          {
            "id": 7,
            "who": "Schools",
            "what": "Top ranked elementary and second grade schools"
          },
          {
            "id": 8,
            "who": "Restaurants",
            "what": "Many upscale dinning options"
          },
          {
            "id": 9,
            "who": "To:",
            "what": "John"
          },
          {
            "id": 10,
            "who": "From:",
            "what": "Marry"
          }

        ]
    }


export const extraction=
    {
        "id":0,
        "name": "Group products",
        "prompts":[
            {
                "id":1,
                "who":"Products:",
                "what":"Oranges grow in California and Florida. Main tomato producers are in Florida, Apples are important product for state of Michigan. Texas is the main producer of beef, and Wisconsin of chees."
            },
            {
                "id":2,
                "who":"Task:",
                "what":"Group the following products by the region."
            },
            {
                "id":3,
                "who":"Task:",
                "what":"Group the regions by the products."
            },

        ]
    }

    export const productdescription =
    {
        "id":0,
        "name": "Brown bag",
        "prompts":[
            {
                "id":1,
                "who":"Task:",
                "what":"Describe the following product:"
            },
            {
                "id":2,
                "who":"What:",
                "what":"Leather bag"
            },
            {
                "id":3,
                "who":"Color:",
                "what":"brown"
            },
            {
                "id":4,
                "who":"Style:",
                "what":"business style"
            },
            {
                "id":5,
                "who":"Price:",
                "what":"$79"
            },

        ]
    }

    export const problemsolving=
    {
        "id":0,
        "name": "Tom and Peter",
        "prompts":[
            {
                "id":1,
                "who":"Who",
                "what":"Tom and Peter"
            },
            {
                "id":2,
                "who":"Location",
                "what":"Tom is in town A, Peter is in town B."
            },
            {
                "id":3,
                "who":"Distance",
                "what":"Distance between town A and town B is 15 miles."
            },
            {
                "id":4,
                "who":"Walking speed",
                "what":`Tom walks 2 mi/h
                \nPeter walks 3mi/h`
            },
            {
                "id":5,
                "who":"Task",
                "what":"If Tom and Peter start walking toward each other at the same time how long is it going to take before they meet?"
            },

        ]
    }

    
    export const floridaoranges= 
    {
      "id": 0,
      "name": "Florida oranges",
      "prompts": [
        {
          "id": 1,
          "who": "Quarterly report: Production of oranges in Florida ",
          "what": "Quarter: January - March"
        },
        {
          "id": 2,
          "who": "1. Overview: ",
          "what": "total production, weather conditions, challenges faced, and future projections for the orange industry in the state"
        },
        {
          "id": 3,
          "who": "2. Total Orange Production ",
          "what": "Total of 2.5 million boxes. 10% increase in production compared to the same period last year."
        },
        {
          "id": 4,
          "who": "3. Weather Conditions: ",
          "what": "Moderate temperatures, with adequate rainfall. Occasional cold fronts and frost events were observed."
        },
        {
          "id": 5,
          "who": "4. Challenges Faced: ",
          "what": "Ongoing threat of citrus diseases, particularly citrus greening. Labor shortage. Raising production cost."
        },
        {
          "id": 6,
          "who": "5. Market Demand and Exports: ",
          "what": "Interest steady during the first quarter both domestic and international. Increased sale: Europe, Canada."
        },
        {
          "id": 7,
          "who": "6. Future Projections:",
          "what": "Production expected to remain stable. Implementation of disease management strategies. Closely watchng weather."
        },
        {
          "id": 8,
          "who": "7. Conclusion: ",
          "what": "Write a report based on the aforementioned facts. Use the same headers."
        }
  
      ]
    }

    export const email= 
    {
      "id": 0,
      "name": "Email",
      "prompts": [
        {
          id: 1,
          who: "To whom:",
          what: "John Smith",
        },
        {
          "id": 2,
          "who": "Subject: Solar panels conference",
          "what": "Planning trip to Hawaii for the Solar panels annual conference."
        },
        {
          "id": 3,
          "who": "Date:",
          "what": "Sept 25-29"
        },
        {
          "id": 4,
          "who": "Regards:",
          "what": "Mike Thomson"
        },
        {
          "id": 5,
          "who": "Task:",
          "what": "Write an email."
        },
        
      ]
    }

    export const travelexpense= 
    {
      "id": 0,
      "name": "Travel expense",
      "prompts": [
        {
          id: 1,
          who: 'Title:',
          what: 'Show this as a header: Trip to New York - travel expense'
        },
        {
          id: 2,
          who: 'Transportation:',
          what: 'Air fare: $560.\nTaxi expense: $156'
        },
        {
          id: 3,
          who: 'Accomodation:',
          what: 'Hotel - 2 nights: $350'
        },
        {
          id: 4,
          who: 'Meals:',
          what: 'Breakfast: $56\nLunch: $78\nDinner: $126\nSnaks: $13'
        },
        {
          id: 5,
          who: 'Task:',
          what: 'List all expanses in a separate line.\nAt the end show total.'
        }
        
      ]
    }